<template>
  <div>
    <div class="heard">
      <div style="cursor: pointer" @click="closeTip">
        <i style="font-size: 28px;display: flex;float: right" class="el-icon-close"></i>
      </div>
      <el-table
        :data="reglist"
        height="640px">
        <el-table-column
          prop="name"
          align="center"
          label="姓名">
        </el-table-column>
        <el-table-column
          align="center"
          label="所属部门">
          <template slot-scope="scope">
            {{ showdepartment(scope.row) }}
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          label="操作">
          <template slot-scope="scope">
            <el-button @click="viaUser(scope.row)" type="success">通过</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import * as req from '@/utils/request'

export default {
  data () {
    return {
      optionsList: [],
      stationList: [],
      reglist: [],
      isUpdate: false
    }
  },
  computed: {},
  created () {
    this.auditList()
  },
  methods: {
    // 通过审核用户
    viaUser (row) {
      let sendData = {}
      sendData.data = {id: row.id}
      sendData.fn = this.viaUserFn
      sendData.vm = this
      req.Post('user/viaUser', sendData)
    },
    showdepartment (row) {
      let result = ''
      let a = this.global.optionsList
      for (let i in a) {
        if (a[i].value === row.branch_id) {
          result = (a[i].label) + '/'
          let arr = a[i].children
          for (let s in arr) {
            if (arr[s].value === row.station_id) {
              return result.concat(arr[s].label)
            }
          }
        }
      }
    },
    viaUserFn (data) {
      if (data.err_code !== 0) {
        this.$message.error('失败！')
        return
      }
      this.$message.success('成功')
      this.auditList()
    },
    // 获取部门列表
    getBranchList () {
      let sendData = {}
      sendData.data = {}
      sendData.fn = this.getBranchListFn
      sendData.vm = this
      req.Post('branch/get_branch', sendData)
    },
    getBranchListFn (data) {
      if (data.err_code !== 0) {
        alert(data.err_msg)
        return
      }
      this.branchList = data.list
    },
    // 获取岗位列表
    getStationList () {
      let sendData = {}
      sendData.data = null
      sendData.fn = this.getStationListFn
      sendData.vm = this
      req.Get('station/get_job', sendData)
    },
    getStationListFn (data) {
      if (data.err_code !== 0) {
        alert(data.err_msg)
        return
      }
      this.stationList = data.list
      this.optionsList = this.getOptions()
    },
    // 生成部门和岗位选项
    getOptions () {
      let branchList = this.branchList
      let stationList = this.stationList
      let ary = []
      for (let i in branchList) {
        let obj = {}
        obj.value = branchList[i].id
        obj.label = branchList[i].branch
        let children = this.getChildren(branchList[i].id, stationList)
        if (children.length > 0) {
          obj.children = children
        }
        ary.push(obj)
      }
      return ary
    },
    // 根据部门id获取所属岗位
    getChildren (branchId, stationList) {
      let ary = []
      for (let i in stationList) {
        if (stationList[i].branch_id === branchId) {
          let obj = {}
          obj.value = stationList[i].id
          obj.label = stationList[i].station
          ary.push(obj)
        }
      }
      return ary
    },
    auditList () {
      let sendData = {}
      sendData.data = {id: 1} // state 1 为需要审核人员
      sendData.fn = this.auditListFn
      sendData.vm = this
      req.Post('user/auditList', sendData)
    },
    auditListFn (data) {
      if (data == null) {
        return
      }
      this.reglist = data.list
    },
    closeTip () {
      this.$parent.$parent.updateDialog = false
      this.$parent.$parent.model = 0
    }
  }
}
</script>

<style scoped>
* {
  overflow: hidden;
}

.heard {
  font-family: 'Muli', sans-serif;
  width: 950px;
  /*border: 5px solid #5b98d6;*/
  border-radius: 10px;
  background-color: rgba(255, 255, 255, 8);
  position: fixed;
  min-height: 70vh;
  max-height: 70vh;
  padding: 15px;
  top: 110px;
  right: 0;
  bottom: 0;
  left: 0;
  margin: 0 auto;
  border-width: 3px 0px 0 0;
  border-style: solid;
  border-color: #66b1ff;
  overflow-y: hidden;
  overflow-x: hidden;
}

/deep/ -webkit-scrollbar {
  width: 0px;
  height: 0px;
}

/deep/ -webkit-scrollbar-thumb {
  background-color: rgba(238, 236, 236, 0.26);
  border-radius: 0px;
}
/deep/ .el-table__body-wrapper::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

/deep/ .el-table__body-wrapper::-webkit-scrollbar-thumb {
  background-color: #ddd;
  border-radius: 3px;
}
</style>



// WEBPACK FOOTER //
// src/components/regPesonlist.vue